import React from "react";
import { history } from "../../compilers/historyProp";
import "../../stylesheet/components/Footer.scss";
import ZefiLogo from "../logo/ZefiLogo";
import FooterCommunity from "./FooterCommunity";
import FooterNavigation from "./FooterNavigation";
import FooterNewsletter from "./FooterNewsletter";
import { useTranslation } from "react-i18next";

type FooterProps = {
  history: history;
};

const Footer: React.FC<FooterProps> = ({ history }) => {
  const pathname = history.location.pathname;
  const { t, i18n } = useTranslation();
  const lang = i18n.language;
  //console.log("current lang:", lang);
  return (
    <footer className="container zefi-footer">
      <div className="footer-top mb-3">
        <div className="col-12 col-lg-3">
          <ZefiLogo
            footerLogo={true}
            logoPath="/img/zefi-logo.svg"
            path={pathname}
          />
          <p className="p2">{t("footer.logo-description")}</p>
        </div>
        <div style={{ cursor: "pointer" }} className="col-12 col-lg-2">
          <FooterNavigation />
        </div>
        {/*<div className="col-12 col-sm-2 col-md-1">*/}
        {/*  <FooterAboutUs />*/}
        {/*</div>*/}
        <div className="col-12 col-md-6 col-lg-3">
          <FooterNewsletter />
        </div>
        <div
          className={`col-12 col-lg-2 ${lang == "en" ? "ps-lg-3" : "pe-lg-3"}`}
        >
          <FooterCommunity />
        </div>
      </div>
      <div className="footer-bottom mb-0 mb-md-2">
        <div className="footer-year p2">
          © {new Date().getFullYear()} ZeFi. All rights reserved
        </div>
      </div>
    </footer>
  );
};

export default Footer;
